import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { SortableHandle } from 'react-sortable-hoc';

import find from 'lodash/find';

import Order from '../../../shared/order-list/main';
import { getCurrencyIcon } from '../../../../../../shared/js/get-currency-icon';
import { formatMoney } from '../../../shared/format';

const DragHandle = SortableHandle(() => <span className="sortable-offers-wrap__item-drag" />);

const Switch = ({
	groupedPayoutSystems,
	systemBalances,
	activePayoutSystemId,
	changePayoutSystem,
	updateSystemBalance,
	can,
	toggleActiveCategory,
	activePayoutSystemCategories,
	orderSortedEnd,
	payoutSystemCategoriesList
}) =>
	<div className="payouts__switch-control">
		<div className="categories-wrap">
			{groupedPayoutSystems.map((entity, i) => {
				return entity.paySystems && entity.paySystems.length ? (
					<div key={i}>
						<div
							className={cn(getActiveCategories(activePayoutSystemCategories, entity) && 'opened', 'category')}
							onClick={() => toggleActiveCategory(entity.category)}>
							{(find(payoutSystemCategoriesList, {id: entity.category}) &&
									find(payoutSystemCategoriesList, {id: entity.category}).text) ||
							entity.category}
						</div>
						<div className={cn({
							opened: getActiveCategories(activePayoutSystemCategories, entity),
							'category-list': true
						})}>
							<Order onSortEnd={orderSortedEnd} useDragHandle={true}>
								{entity.paySystems.map((item, index) => {
									return (
										<Order.Item
											id={item.id}
											key={index}>
											<div
												title={item.title}
												className={cn({
													'system-container': true,
													active: item.id === activePayoutSystemId
												})}
												onClick={() => changePayoutSystem(item.id)}>
												{item.image && <img src={item.image}/>}
												<div className="name-balance-wrap">
													<div className="name">
														<span className="name-text">{item.title}</span>
													</div>
													{ systemBalances[item.id] && can('viewBalances') &&
														<div className="balance">
															<span onClick={e => {
																e.stopPropagation();
																updateSystemBalance(item.id);}
															}>
																{formatMoney(systemBalances[item.id], true)} {getCurrencyIcon(item.currency)}
															</span>
														</div> }
												</div>
												{can('changePayoutSystemDisplayPriority') && <DragHandle />}
												{!!Number(item.total_affiliates_requesting_payouts) && (
													<span className="total-payouts">{item.total_affiliates_requesting_payouts}</span>
												)}
											</div>
										</Order.Item>
									);
								})}
							</Order>
						</div>
					</div>
				) : null;
			})}
		</div>
	</div>;

Switch.propTypes = {
	can: PropTypes.func,
	groupedPayoutSystems: PropTypes.array,
	systemBalances: PropTypes.object,
	activePayoutSystemId: PropTypes.number,
	changePayoutSystem: PropTypes.func,
	updateSystemBalance: PropTypes.func,
	toggleActiveCategory: PropTypes.func,
	activePayoutSystemCategories: PropTypes.array,
	orderSortedEnd: PropTypes.func,
	payoutSystemCategoriesList: PropTypes.array
};

const getActiveCategories = (activePayoutSystemCategories, entity) => {
	return find(activePayoutSystemCategories, { category: entity.category }).active;
};

export default Switch;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/switch/main.js